import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Appcost(props) {
    return (
        <div className="p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="TekRevol">
                            <h2>Opt For TekRevol Managed Mobility Services Today!</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>TekRevol’s managed mobility services enable you to have all the required functionalities with complete security protocols and usage optimizations. Talk to us now for more.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Appcost;
